import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonCardContent,
  IonList,
  IonItemGroup,
  IonItemDivider,
  IonItem,
} from "@ionic/vue";
import {
  nextTick,
  onBeforeUnmount,
  onMounted,
  PropType,
  ref,
  watch,
} from "vue";
import {
  ColorObject,
  EnrollmentCardElements,
  CustomElement,
  OrderedCardsList,
  Classes,
  CardsListElements,
  Colors,
  GeneralCardSubElements,
  TmpList,
  CardsGridElements,
  CustomSubElements,
} from "../types";
import {
  getIonicColor,
  isGeneral,
  isCourse,
  canVModel,
  canCardListVModel,
  adjustColor,
  hasNoData,
  getBreakpoint,
  getBreakpointClasses,
} from "../utils";
import { getCssColor } from "../utils";
import { WatchStopHandle } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ListCard',
  props: {
  title: Object as PropType<CustomElement>,
  subtitle: Object as PropType<CustomElement>,
  emptiness_message: {
    type: Object as PropType<CustomElement>,
    required: true,
  },
  cards_list: {
    type: Object as PropType<OrderedCardsList>,
    required: true,
  },
  columns: {
    type: [Number, Object] as PropType<number | TmpList<number>>,
    default() {
      return 1;
    },
  },
  colors: Object as PropType<Colors<GeneralCardSubElements>>,
  classes: Object as PropType<Classes<CardsListElements | CardsGridElements>>,
},
  emits: [
  "execute_link",
  "signal_event",
  "update:title",
  "update:subtitle",
  "update:emptiness_message",
  "update:cards_list",
],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "7f971c23": (_unref(css_background_color)),
  "0abe02a2": (_unref(css_dividers_color))
}))

const setSpecificColors = (
  specific_colors: Colors<CustomSubElements> | undefined
) => Object.assign(general_card_colors ?? {}, specific_colors);
const onlyLists = () => {
  const groups = Object.keys(props.columns);

  let is_list;
  let count = 0;

  if (
    !(is_list =
      props.columns === 1 ||
      (cards_list_ref.value.cards[""] != undefined &&
        typeof props.columns != "number" &&
        props.columns[""] == 1))
  ) {
    while (
      (is_list = (props.columns as TmpList<number>)[groups[count]] == 1) &&
      ++count < groups.length
    );
  }

  return is_list;
};
const checkVModel = () =>
  props.cards_list.order.find((order_element) =>
    canVModel(order_element.title)
  ) != undefined || canCardListVModel(props.cards_list.cards);
const addListeners = () => {
  watch(
    () => props.cards_list,
    (value) => {
      cards_list_ref.value = value;
    }
  );
  watch(
    () => cards_list_ref.value,
    (value) => {
      emit("update:cards_list", value);
    }
  );
};
const updateBreakpoint = () => {
  breakpoint.value = getBreakpoint(window.innerWidth);
};




const title_ref = ref(props.title);
const subtitle_ref = ref(props.subtitle);
const emptiness_message_ref = ref(props.emptiness_message);
const cards_list_ref = ref(props.cards_list);
const breakpoint = ref(getBreakpoint(window.innerWidth));

const css_background_color =
  props.colors?.background != undefined
    ? getCssColor(props.colors.background)
    : undefined;
const css_dividers_color =
  props.colors?.dividers != undefined
    ? getCssColor(props.colors.dividers)
    : undefined;
const groups = Object.keys(cards_list_ref.value.cards);
const general_card_colors:
  | {
      [key in keyof string as CustomSubElements]?: ColorObject;
    }
  | undefined =
  props.colors?.background != undefined ||
  props.colors?.cards_borders != undefined
    ? {
        background: props.colors?.background,
        borders: props.colors?.cards_borders,
      }
    : undefined;

let tmp_card;
let tmp_color: ColorObject | undefined = undefined;
let stopWatch: WatchStopHandle;

if (props.title != undefined && title_ref.value != undefined) {
  if (title_ref.value.colors == undefined) {
    title_ref.value.colors = {};
  }
  title_ref.value.colors.text = adjustColor(
    props.title?.colors?.text,
    props.colors?.text
  );
}
if (props.subtitle != undefined && subtitle_ref.value != undefined) {
  if (subtitle_ref.value.colors == undefined) {
    subtitle_ref.value.colors = {};
  }
  subtitle_ref.value.colors.text = adjustColor(
    props.subtitle?.colors?.text,
    props.colors?.text
  );
}
if (emptiness_message_ref.value.colors == undefined) {
  emptiness_message_ref.value.colors = {};
}
emptiness_message_ref.value.colors.text = adjustColor(
  props.emptiness_message?.colors?.text,
  props.colors?.text
);
if (emptiness_message_ref.value.classes == undefined) {
  emptiness_message_ref.value.classes = {};
}
emptiness_message_ref.value.classes.label = {
  "ion-text-wrap": true,
  "ion-text-center": true,
};
for (const card_group of cards_list_ref.value.order) {
  if (card_group.title.classes == undefined) {
    card_group.title.classes = {};
  }
  card_group.title.classes.label = {
    "ion-padding-end": true,
    "item-text-wrap": true,
  };
}

for (const group in groups) {
  for (const card in cards_list_ref.value.cards[groups[group]]) {
    tmp_card = cards_list_ref.value.cards[groups[group]][card];
    if (isGeneral(tmp_card)) {
      if (tmp_card.title != undefined) {
        tmp_color = adjustColor(
          tmp_card.title.colors?.text,
          props.colors?.text
        );
        if (tmp_color != undefined) {
          if (tmp_card.title.colors == undefined) {
            tmp_card.title.colors = {};
          }
          tmp_card.title.colors.text = tmp_color;
        }
      }
      if (tmp_card.subtitle != undefined) {
        tmp_color = adjustColor(
          tmp_card.subtitle.colors?.text,
          props.colors?.text
        );
        if (tmp_color != undefined) {
          if (tmp_card.subtitle.colors == undefined) {
            tmp_card.subtitle.colors = {};
          }
          tmp_card.subtitle.colors.text = tmp_color;
        }
      }
      if (tmp_card.content != undefined) {
        for (const element of tmp_card.content) {
          tmp_color = adjustColor(element.colors?.text, props.colors?.text);
          if (tmp_color != undefined) {
            if (element.colors == undefined) {
              element.colors = {};
            }
            element.colors.text = tmp_color;
          }
        }
      }
      tmp_card.colors = setSpecificColors(tmp_card.colors);
    } else if (isCourse(tmp_card)) {
      tmp_card.enrollment = (
        props.cards_list.cards[groups[group]][card] as EnrollmentCardElements
      ).enrollment;

      tmp_color = adjustColor(
        tmp_card.content[0].colors?.text,
        props.colors?.background
      );
      if (tmp_color != undefined) {
        if (tmp_card.content[0].colors == undefined) {
          tmp_card.content[0].colors = {};
        }
        tmp_card.content[0].colors.text = tmp_color;
      }

      tmp_color = adjustColor(
        tmp_card.content[1].colors?.text,
        props.colors?.text
      );
      if (tmp_color != undefined) {
        if (tmp_card.content[1].colors == undefined) {
          tmp_card.content[1].colors = {};
        }
        tmp_card.content[1].colors.text = tmp_color;
      }
    }
  }
}
for (const ordered_cards of cards_list_ref.value.order) {
  tmp_color = adjustColor(
    ordered_cards.title.colors?.text,
    props.colors?.dividers_text,
    props.colors?.background
  );
  if (tmp_color != undefined) {
    if (ordered_cards.title.colors == undefined) {
      ordered_cards.title.colors = {};
    }
    ordered_cards.title.colors.text = tmp_color;
  }
}

if (canVModel(props.emptiness_message)) {
  watch(
    () => props.emptiness_message,
    (value) => {
      emptiness_message_ref.value = value;
    }
  );
  watch(
    () => emptiness_message_ref.value,
    (value) => {
      emit("update:title", value);
    }
  );
}
if (props.title != undefined && canVModel(props.title)) {
  watch(
    () => props.title,
    (value) => {
      title_ref.value = value;
    }
  );
  watch(
    () => title_ref.value,
    (value) => {
      emit("update:title", value);
    }
  );
}
if (props.subtitle != undefined && canVModel(props.subtitle)) {
  watch(
    () => props.subtitle,
    (value) => {
      subtitle_ref.value = value;
    }
  );
  watch(
    () => subtitle_ref.value,
    (value) => {
      emit("update:subtitle", value);
    }
  );
}
if (hasNoData(props.cards_list)) {
  stopWatch = watch(
    () => props.cards_list,
    (value) => {
      cards_list_ref.value = value;
      if (!hasNoData(value) && checkVModel()) {
        addListeners();
        stopWatch();
      }
    }
  );
} else if (checkVModel()) {
  addListeners();
}

if (
  props.classes?.card != undefined ||
  props.classes?.header != undefined ||
  props.classes?.content != undefined ||
  props.classes?.list != undefined ||
  props.classes?.divider != undefined
) {
  onMounted(() =>
    nextTick(() => {
      window.addEventListener("resize", updateBreakpoint);
    })
  );

  onBeforeUnmount(() => {
    window.removeEventListener("resize", updateBreakpoint);
  });

  watch(
    () => window.innerWidth,
    (newWidth) => {
      breakpoint.value = getBreakpoint(newWidth);
    }
  );
}

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!
  const _component_card_item = _resolveComponent("card-item")!
  const _component_group_list = _resolveComponent("group-list")!
  const _component_cards_grid = _resolveComponent("cards-grid")!

  return (_openBlock(), _createBlock(_unref(IonCard), {
    color: _unref(getIonicColor)(__props.colors?.background),
    class: _normalizeClass({
      ..._unref(getBreakpointClasses)(__props.classes?.card, breakpoint.value),
      '--ion-no-border': __props.colors?.external_borders == undefined,
      background:
        __props.colors?.background != undefined &&
        _unref(getIonicColor)(__props.colors?.background) == undefined,
    })
  }, {
    default: _withCtx(() => [
      (__props.title != undefined)
        ? (_openBlock(), _createBlock(_unref(IonCardHeader), {
            key: 0,
            class: _normalizeClass(_unref(getBreakpointClasses)(__props.classes?.header, breakpoint.value))
          }, {
            default: _withCtx(() => [
              (__props.title != undefined)
                ? (_openBlock(), _createBlock(_unref(IonCardTitle), { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ionic_element, {
                        element: title_ref.value,
                        "onUpdate:element": _cache[0] || (_cache[0] = ($event: any) => ((title_ref).value = $event))
                      }, null, 8, ["element"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (__props.subtitle != undefined)
                ? (_openBlock(), _createBlock(_unref(IonCardSubtitle), { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ionic_element, {
                        element: subtitle_ref.value,
                        "onUpdate:element": _cache[1] || (_cache[1] = ($event: any) => ((subtitle_ref).value = $event))
                      }, null, 8, ["element"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonCardContent), {
        style: {"overflow-y":"auto"},
        class: _normalizeClass(_unref(getBreakpointClasses)(__props.classes?.content, breakpoint.value))
      }, {
        default: _withCtx(() => [
          (_unref(hasNoData)(cards_list_ref.value))
            ? (_openBlock(), _createBlock(_unref(IonItem), {
                key: 0,
                color: _unref(getIonicColor)(__props.colors?.background),
                class: _normalizeClass([{
            background:
              __props.colors?.background != undefined &&
              _unref(getIonicColor)(__props.colors?.background) == undefined,
          }, "ion-no-padding"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ionic_element, {
                    element: emptiness_message_ref.value,
                    "onUpdate:element": _cache[2] || (_cache[2] = ($event: any) => ((emptiness_message_ref).value = $event))
                  }, null, 8, ["element"])
                ]),
                _: 1
              }, 8, ["color", "class"]))
            : (onlyLists())
              ? (_openBlock(), _createBlock(_unref(IonList), {
                  key: 1,
                  class: _normalizeClass(["ion-no-padding", _unref(getBreakpointClasses)(__props.classes?.list, breakpoint.value)])
                }, {
                  default: _withCtx(() => [
                    (cards_list_ref.value.cards[''] != undefined)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(cards_list_ref.value.cards[''], (card, i) => {
                          return (_openBlock(), _createBlock(_component_card_item, {
                            key: card.id,
                            card: cards_list_ref.value.cards[''][i],
                            "onUpdate:card": ($event: any) => ((cards_list_ref.value.cards[''][i]) = $event),
                            colors: __props.colors,
                            classes: __props.classes,
                            onExecute_link: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('execute_link'))),
                            onSignal_event: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('signal_event')))
                          }, null, 8, ["card", "onUpdate:card", "colors", "classes"]))
                        }), 128))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(cards_list_ref.value.order, (ordered_cards, i) => {
                          return (_openBlock(), _createBlock(_unref(IonItemGroup), {
                            key: 'group-' + ordered_cards.key
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_group_list, {
                                emptiness_message: emptiness_message_ref.value,
                                "onUpdate:emptiness_message": _cache[5] || (_cache[5] = ($event: any) => ((emptiness_message_ref).value = $event)),
                                divider: cards_list_ref.value.order[i].title,
                                "onUpdate:divider": ($event: any) => ((cards_list_ref.value.order[i].title) = $event),
                                cards_list: cards_list_ref.value.cards[ordered_cards.key],
                                "onUpdate:cards_list": ($event: any) => ((cards_list_ref.value.cards[ordered_cards.key]) = $event),
                                colors: __props.colors,
                                classes: __props.classes,
                                onExecute_link: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('execute_link'))),
                                onSignal_event: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('signal_event')))
                              }, null, 8, ["emptiness_message", "divider", "onUpdate:divider", "cards_list", "onUpdate:cards_list", "colors", "classes"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                  ]),
                  _: 1
                }, 8, ["class"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (cards_list_ref.value.cards[''] != undefined)
                    ? (_openBlock(), _createBlock(_component_cards_grid, {
                        key: 0,
                        cards_list: cards_list_ref.value.cards[''],
                        "onUpdate:cards_list": _cache[8] || (_cache[8] = ($event: any) => ((cards_list_ref.value.cards['']) = $event)),
                        columns: typeof __props.columns == 'number' ? __props.columns : __props.columns[''],
                        colors: __props.colors,
                        classes: __props.classes,
                        onExecute_link: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('execute_link'))),
                        onSignal_event: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('signal_event')))
                      }, null, 8, ["cards_list", "columns", "colors", "classes"]))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(cards_list_ref.value.order, (ordered_cards, i) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: 'group-' + ordered_cards.key
                        }, [
                          (
                (typeof __props.columns == 'number'
                  ? __props.columns
                  : __props.columns[ordered_cards.key]) == 1
              )
                            ? (_openBlock(), _createBlock(_unref(IonList), { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonItemGroup), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_group_list, {
                                        emptiness_message: emptiness_message_ref.value,
                                        "onUpdate:emptiness_message": _cache[11] || (_cache[11] = ($event: any) => ((emptiness_message_ref).value = $event)),
                                        divider: cards_list_ref.value.order[i].title,
                                        "onUpdate:divider": ($event: any) => ((cards_list_ref.value.order[i].title) = $event),
                                        cards_list: cards_list_ref.value.cards[ordered_cards.key],
                                        "onUpdate:cards_list": ($event: any) => ((cards_list_ref.value.cards[ordered_cards.key]) = $event),
                                        colors: __props.colors,
                                        classes: __props.classes,
                                        onExecute_link: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('execute_link'))),
                                        onSignal_event: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('signal_event')))
                                      }, null, 8, ["emptiness_message", "divider", "onUpdate:divider", "cards_list", "onUpdate:cards_list", "colors", "classes"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_unref(IonItemDivider), {
                                  color: _unref(getIonicColor)(__props.colors?.dividers) ?? 'light',
                                  class: _normalizeClass({
                  ...__props.classes?.divider,
                  dividers_background:
                    __props.colors?.dividers != undefined &&
                    _unref(getIonicColor)(__props.colors?.dividers) == undefined,
                })
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ionic_element, {
                                      element: cards_list_ref.value.order[i].title,
                                      "onUpdate:element": ($event: any) => ((cards_list_ref.value.order[i].title) = $event)
                                    }, null, 8, ["element", "onUpdate:element"])
                                  ]),
                                  _: 2
                                }, 1032, ["color", "class"]),
                                (cards_list_ref.value.cards[ordered_cards.key].length === 0)
                                  ? (_openBlock(), _createBlock(_unref(IonItem), {
                                      key: 0,
                                      color: _unref(getIonicColor)(__props.colors?.background),
                                      class: _normalizeClass([{
                  background:
                    __props.colors?.background != undefined &&
                    _unref(getIonicColor)(__props.colors?.background) == undefined,
                }, "ion-no-padding"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ionic_element, {
                                          element: emptiness_message_ref.value,
                                          "onUpdate:element": _cache[14] || (_cache[14] = ($event: any) => ((emptiness_message_ref).value = $event))
                                        }, null, 8, ["element"])
                                      ]),
                                      _: 1
                                    }, 8, ["color", "class"]))
                                  : (_openBlock(), _createBlock(_component_cards_grid, {
                                      key: 1,
                                      cards_list: cards_list_ref.value.cards[ordered_cards.key],
                                      "onUpdate:cards_list": ($event: any) => ((cards_list_ref.value.cards[ordered_cards.key]) = $event),
                                      columns: 
                    typeof __props.columns == 'number'
                      ? __props.columns
                      : __props.columns[ordered_cards.key]
                  ,
                                      colors: __props.colors,
                                      classes: __props.classes,
                                      onExecute_link: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('execute_link'))),
                                      onSignal_event: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('signal_event')))
                                    }, null, 8, ["cards_list", "onUpdate:cards_list", "columns", "colors", "classes"]))
                              ], 64))
                        ], 64))
                      }), 128))
                ], 64))
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }, 8, ["color", "class"]))
}
}

})